import { render, staticRenderFns } from "./ContentPart.vue?vue&type=template&id=3a00af5c&"
import script from "./ContentPart.vue?vue&type=script&lang=js&"
export * from "./ContentPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3a00af5c', component.options)
    } else {
      api.reload('3a00af5c', component.options)
    }
    module.hot.accept("./ContentPart.vue?vue&type=template&id=3a00af5c&", function () {
      api.rerender('3a00af5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/page-part/ContentPart.vue"
export default component.exports